/**
 * QuotationLineApprovalService
 * Service for QuotationLineApproval entity operations
 * Route: api/quotationlineapproval
 * Controller: QuotationLineApprovalController.cs
 */
import { CrudService } from '../base/CrudService';
export class QuotationLineApprovalService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? QuotationLineApprovalService.DEFAULT_SERVICE_PATH,
            basePath: QuotationLineApprovalService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all approvals for a specific quotation
     */
    async getByQuotation(quotationId) {
        const response = await this.http.get(this.buildUrl(`quotation/${quotationId}`));
        return response.data ?? [];
    }
    /**
     * Get all approvals for a specific request
     */
    async getByRequest(requestId) {
        const response = await this.http.get(this.buildUrl(`request/${requestId}`));
        return response.data ?? [];
    }
    /**
     * Get all approvals for a specific quotation line
     */
    async getByQuotationLine(quotationLineId) {
        const response = await this.http.get(this.buildUrl(`line/${quotationLineId}`));
        return response.data ?? [];
    }
}
QuotationLineApprovalService.DEFAULT_SERVICE_PATH = 'procurements';
QuotationLineApprovalService.BASE_PATH = 'api/quotationlineapproval';
//# sourceMappingURL=QuotationLineApprovalService.js.map